import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import Alert from 'react-s-alert';
import { NodeHotKey } from 'libs/editor/plugins/helpers/nodeHotKey';
import { RenderNode } from 'libs/editor/plugins/helpers/renderNode';
import { HasInline } from 'libs/editor/plugins/helpers/hasInline';

import { LinkStyle } from 'libs/editor/styles';

@observer
class LinkNode extends React.Component {
  render() {
    const { attributes, node, children } = this.props;
    const { data } = node;
    const href = data.get('href');

    return (
      <LinkStyle href={href} target='_blank' rel='noopener' {...attributes}>
        {children}
      </LinkStyle>
    );
  }
}

LinkNode.propTypes = {
  node: PropTypes.object,
  children: PropTypes.node,
  attributes: PropTypes.object,
};

const type = 'link';
const active = value => HasInline(type, value);

export function Link() {
  return {
    button: {
      elementType: 'inline',
      type,
      active,
      handleClick: store => {
        const { value, reference, onChange, toolbarStore } = store;
        if (store.selection.width === 0 || store.selection.height === 0) {
          Alert.error('Please select the text you want to linkify');
          return;
        }

        if (active(value)) {
          onChange(reference.unwrapInline(type));
        } else {
          toolbarStore.SetInputStatus(true);
        }
      },
    },
    plugins: [
      NodeHotKey({ key: 'l', type }),
      RenderNode(type, props => <LinkNode {...props} />),
    ],
  };
}
